import React from "react";

import { TOOLTIPS } from "@app/common/content";

import { TeamSettingModuleProps } from "./types";
import OnOffSetting from "../components/OnOffSetting";
import WorkspaceSettingsAccordion from "../components/WorkspaceSettingsAccordion";

const TeamReportingFeaturesModule = ({
  onSettingUpdate,
  settings,
  workspaceIsInactive,
}: TeamSettingModuleProps) => {
  return (
    <WorkspaceSettingsAccordion
      title="Reporting Features"
      subtitle="Determine the visibility of reporting components in Meeting Reports and Meeting Tools"
    >
      <OnOffSetting
        title="Transcripts"
        subtitle="Team members can view transcripts in their Meeting Reports"
        locked={workspaceIsInactive || !settings.transcripts.edit}
        isOn={settings.transcripts.view}
        onChange={onSettingUpdate("transcripts")}
        tooltip={workspaceIsInactive ? TOOLTIPS.upsell.upgradeToPro : undefined}
        bottomDivider
      />
      <OnOffSetting
        title="Audio & Video Playback"
        subtitle="Team members can view meeting playback in their Meeting Reports"
        locked={workspaceIsInactive || !settings.storeRecording.edit}
        isOn={settings.storeRecording.view}
        onChange={onSettingUpdate("storeRecording")}
        tooltip={workspaceIsInactive ? TOOLTIPS.upsell.upgradeToPro : undefined}
      />
    </WorkspaceSettingsAccordion>
  );
};

export default TeamReportingFeaturesModule;
